// ZB Product Information - COMPLETE REWRITTEN VERSION v5
// ✅ Store currency only (no Transcy)
// ✅ FIXED: Robust currency detection (data-shop-currency → Shopify.currency → INR fallback)
// ✅ FIXED: Case-insensitive, highly robust multi-option variant matching
// ✅ FIXED: Button state relies purely on Shopify's "available" truth
// ✅ Improved inventory detection for all variant types

(function () {
  function initMediaGallery(root) {
    var thumbs = root.querySelectorAll('.zb-pi__thumb');
    var mediaItems = root.querySelectorAll('.zb-pi__main-media-item');
    if (!thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.getAttribute('data-media-id');
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        mediaItems.forEach(function (item) {
          item.classList.toggle('active', item.getAttribute('data-media-id') === id);
        });
      });
    });
  }

  function initQuantity(root) {
    var input = root.querySelector('[data-qty-input]');
    var decrease = root.querySelector('[data-qty-decrease]');
    var increase = root.querySelector('[data-qty-increase]');
    if (!input) return;

    if (decrease) {
      decrease.addEventListener('click', function () {
        var val = Math.max(1, parseInt(input.value, 10) - 1 || 1);
        input.value = val;
      });
    }
    if (increase) {
      increase.addEventListener('click', function () {
        var val = (parseInt(input.value, 10) || 1) + 1;
        input.value = val;
      });
    }
  }

  // ---------------------------------------------------------
  // ROBUST SHOP CURRENCY DETECTION (v5 FIX)
  // Priority: data-shop-currency attribute -> Shopify.currency.active
  // -> Shopify.currency -> hard fallback to INR (store default)
  // ---------------------------------------------------------
  function getShopCurrency() {
    var fromAttr = document.documentElement.getAttribute('data-shop-currency');
    if (fromAttr) return fromAttr.trim().toUpperCase();

    if (window.Shopify && window.Shopify.currency) {
      if (window.Shopify.currency.active) {
        return String(window.Shopify.currency.active).toUpperCase();
      }
      if (typeof window.Shopify.currency === 'string') {
        return window.Shopify.currency.toUpperCase();
      }
    }

    console.warn('⚠️ data-shop-currency not found on <html>. Add data-shop-currency="{{ shop.currency }}" to theme.liquid. Falling back to INR.');
    return 'INR';
  }

  function initVariantPicker(root) {
    var picker = root.querySelector('[data-pi-variant-picker]');
    if (!picker) return;

    var optionButtons = picker.querySelectorAll('.zb-pi__option-btn, .zb-pi__swatch');
    var nativeSelect = root.querySelector('[data-pi-variant-select]');
    var formVariantInput = root.querySelector('[data-pi-form-variant-id]');
    var priceEl = root.querySelector('[data-pi-price]');
    var stickyPrice = root.querySelector('[data-pi-sticky-price]');
    var addToCartBtn = root.querySelector('[type="submit"]');

    var mediaMapEl = root.querySelector('[data-pi-variant-media-map]');
    var variantMediaMap = {};
    if (mediaMapEl) {
      try {
        variantMediaMap = JSON.parse(mediaMapEl.textContent);
      } catch (e) {
        variantMediaMap = {};
      }
    }

    // Load variant data
    var variantDataEl = root.querySelector('[data-pi-variant-data]');
    var variantData = {};
    if (variantDataEl) {
      try {
        variantData = JSON.parse(variantDataEl.textContent);
        console.log('✅ Variant data loaded:', Object.keys(variantData).length, 'variants');
      } catch (e) {
        console.error('❌ Failed to parse variant data:', e);
        variantData = {};
      }
    }

    // Get shop currency (robust detection, no hardcoded USD fallback)
    var shopCurrency = getShopCurrency();

    // Currency symbols mapping
    var currencySymbols = {
      'USD': '$', 'EUR': '€', 'GBP': '£', 'INR': '₹', 'CAD': '$',
      'AUD': '$', 'JPY': '¥', 'CNY': '¥', 'CHF': 'CHF', 'SEK': 'kr',
      'NOK': 'kr', 'DKK': 'kr', 'NZD': '$', 'SGD': '$', 'HKD': '$',
      'BRL': 'R$', 'MXN': '$'
    };

    function formatPrice(priceInCents) {
      var price = priceInCents / 100;
      var symbol = currencySymbols[shopCurrency] || shopCurrency;
      return symbol + price.toFixed(2);
    }

    function updateInventoryDisplay(variantId) {
      var data = variantData[variantId];
      var inventoryEl = root.querySelector('[data-pi-inventory]');

      if (!inventoryEl) return;

      if (!data || !data.available || data.inventory_quantity == null || data.inventory_quantity <= 0) {
        inventoryEl.style.display = 'none';
        return;
      }

      var qty = data.inventory_quantity;
      inventoryEl.style.display = 'block';

      var textEl = inventoryEl.querySelector('.zb-pi__inventory-text');
      if (textEl) {
        textEl.textContent = 'Only ' + qty + ' left in stock';
      }

      var barEl = inventoryEl.querySelector('.zb-pi__inventory-bar-fill');
      if (barEl) {
        var base = parseInt(inventoryEl.getAttribute('data-inventory-base') || 20, 10);
        var pct = (qty * 100.0 / base);
        if (pct > 100) pct = 100;
        barEl.style.width = pct + '%';
      }
    }

    function updateAddToCartButton(variantId) {
      if (!addToCartBtn) return;

      var data = variantData[variantId];

      if (!data) {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Sold out';
        return;
      }

      var isAvailable = (data.available === true || data.available === 'true' || data.available === 1);

      if (isAvailable) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'Add to cart';
        addToCartBtn.classList.remove('sold-out');
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Sold out';
        addToCartBtn.classList.add('sold-out');
      }
    }

    function updatePriceDisplay(variantId) {
      var data = variantData[variantId];
      if (!data || !priceEl) return;

      // <span class="money"> wrappers so Nova/currency apps can detect the price text
      var priceHtml = '';
      if (data.compare_at_price > data.price) {
        priceHtml = '<span class="zb-pi__price-compare" style="text-decoration: line-through; opacity: 0.6; margin-right: 8px;"><span class="money">' + formatPrice(data.compare_at_price) + '</span></span>';
        priceHtml += '<span class="zb-pi__price-current" style="font-weight: bold; color: #000000;"><span class="money">' + formatPrice(data.price) + '</span></span>';
      } else {
        priceHtml = '<span class="zb-pi__price-current" style="font-weight: bold;"><span class="money">' + formatPrice(data.price) + '</span></span>';
      }

      priceEl.innerHTML = priceHtml;

      // Update sticky price if exists
      if (stickyPrice) {
        stickyPrice.innerHTML = '<span style="font-weight: bold;"><span class="money">' + formatPrice(data.price) + '</span></span>';
      }

      // Trigger Nova (and standard Shopify apps) to re-scan and convert the new variant price
      setTimeout(function () {
        if (window.Currency && typeof window.Currency.convertAll === 'function') {
          window.Currency.convertAll();
        }
        // Secondary trigger for modern apps relying on DOM events
        document.dispatchEvent(new CustomEvent('currency:update'));
      }, 150);
    }

    function switchGalleryToMedia(mediaId) {
      if (!mediaId) return;
      var mediaIdStr = String(mediaId);

      var thumbs = root.querySelectorAll('.zb-pi__thumb');
      var mediaItems = root.querySelectorAll('.zb-pi__main-media-item');

      var matchedThumb = null;
      thumbs.forEach(function (thumb) {
        var isMatch = thumb.getAttribute('data-media-id') === mediaIdStr;
        thumb.classList.toggle('active', isMatch);
        if (isMatch) matchedThumb = thumb;
      });

      mediaItems.forEach(function (item) {
        item.classList.toggle('active', item.getAttribute('data-media-id') === mediaIdStr);
      });

      if (matchedThumb && matchedThumb.scrollIntoView) {
        matchedThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    }

    // ---------------------------------------------------------
    // ENHANCED MULTI-OPTION MATCHING LOGIC (v4 FIX, unchanged)
    // ---------------------------------------------------------
    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.zb-pi__option');
        if (group) {
          group.querySelectorAll('.zb-pi__option-btn, .zb-pi__swatch').forEach(function (b) {
            b.classList.remove('active');
          });
        }
        btn.classList.add('active');

        // Gather options and normalize them (trim spaces, make lowercase)
        var selectedValues = [];
        picker.querySelectorAll('.zb-pi__option').forEach(function (optGroup) {
          var active = optGroup.querySelector('.active');
          if (active) {
            selectedValues.push(active.getAttribute('data-option-value').trim().toLowerCase());
          }
        });

        console.log('🎯 User Selection:', selectedValues);

        if (nativeSelect) {
          var options = Array.prototype.slice.call(nativeSelect.options);
          var bestMatch = null;

          options.forEach(function (opt) {
            if (opt.value === '' || !opt.value) return;
            var optData = variantData[opt.value];
            if (!optData) return;

            // Normalize variant title (e.g., "14 / Raw Curly / Black Grey")
            var variantTitle = (optData.title || opt.textContent).toLowerCase();

            // Split by standard Shopify separators to get exact parts
            var variantParts = variantTitle.split(/[\/\-]/).map(function (p) { return p.trim(); });

            // Ensure EVERY selected value exists exactly in the variant parts
            var isMatch = selectedValues.every(function (val) {
              return variantParts.indexOf(val) !== -1 || variantTitle.indexOf(val) !== -1;
            });

            if (isMatch) {
              bestMatch = opt;
            }
          });

          if (bestMatch) {
            console.log('✅ Matched Variant Data:', variantData[bestMatch.value]);
            nativeSelect.value = bestMatch.value;
            if (formVariantInput) formVariantInput.value = bestMatch.value;

            var mediaId = variantMediaMap[bestMatch.value];
            if (mediaId) {
              switchGalleryToMedia(mediaId);
            }

            // Update all displays
            updateInventoryDisplay(bestMatch.value);
            updateAddToCartButton(bestMatch.value);
            updatePriceDisplay(bestMatch.value);
          } else {
            console.warn('❌ NO MATCH FOUND for combination:', selectedValues);
            // Safety fallback to prevent users buying non-existent combinations
            if (addToCartBtn) {
              addToCartBtn.disabled = true;
              addToCartBtn.textContent = 'Unavailable';
              addToCartBtn.classList.add('sold-out');
            }
          }
        }
      });
    });

    // Initialize on page load
    setTimeout(function () {
      // Find all active buttons across ALL option groups
      var activeBtns = picker.querySelectorAll('.zb-pi__option-btn.active, .zb-pi__swatch.active');

      // If none are active by default, pick the first one of each group to establish a baseline
      if (activeBtns.length === 0) {
        picker.querySelectorAll('.zb-pi__option').forEach(function (group) {
          var firstBtn = group.querySelector('.zb-pi__option-btn, .zb-pi__swatch');
          if (firstBtn) firstBtn.classList.add('active');
        });
        activeBtns = picker.querySelectorAll('.zb-pi__option-btn.active, .zb-pi__swatch.active');
      }

      // Click the last active button to trigger the whole update cycle
      if (activeBtns.length > 0) {
        activeBtns[activeBtns.length - 1].click();
      }

      // Force update button state after initialization
      var currentVariantId = nativeSelect ? nativeSelect.value : (formVariantInput ? formVariantInput.value : null);
      if (currentVariantId) {
        setTimeout(function () {
          updateAddToCartButton(currentVariantId);
          updatePriceDisplay(currentVariantId);
          updateInventoryDisplay(currentVariantId);
        }, 200);
      }
    }, 150);
  }

  function initSizingGuide(root) {
    var trigger = root.querySelector('[data-sizing-guide-trigger]');
    var panel = root.querySelector('[data-sizing-guide-panel]');
    if (!trigger || !panel) return;

    trigger.addEventListener('click', function () {
      panel.removeAttribute('hidden');
    });

    panel.querySelectorAll('[data-sizing-guide-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        panel.setAttribute('hidden', '');
      });
    });
  }

  function initSidePanels(root) {
    var triggers = root.querySelectorAll('[data-side-panel-trigger]');
    triggers.forEach(function (trigger) {
      var id = trigger.getAttribute('data-side-panel-trigger');
      var panel = root.querySelector('[data-side-panel="' + id + '"]');
      if (!panel) return;

      trigger.addEventListener('click', function () {
        panel.removeAttribute('hidden');
      });

      panel.querySelectorAll('[data-side-panel-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          panel.setAttribute('hidden', '');
        });
      });
    });
  }

  function initCollapsibleRows(root) {
    var buttons = root.querySelectorAll('[data-pi-toggle]');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var panelId = button.getAttribute('aria-controls');
        var panel = document.getElementById(panelId);
        if (!panel) return;

        var isOpen = button.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          requestAnimationFrame(function () {
            panel.style.maxHeight = '0px';
          });
          button.setAttribute('aria-expanded', 'false');
          panel.addEventListener('transitionend', function handler() {
            panel.setAttribute('hidden', '');
            panel.removeEventListener('transitionend', handler);
          });
        } else {
          panel.removeAttribute('hidden');
          panel.style.maxHeight = '0px';
          requestAnimationFrame(function () {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          });
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initWishlist(root) {
    var btn = root.querySelector('[data-wishlist-toggle]');
    if (!btn) return;

    var productId = btn.getAttribute('data-product-id');
    var storageKey = 'zb-wishlist';

    function getWishlist() {
      try {
        return JSON.parse(localStorage.getItem(storageKey)) || [];
      } catch (e) {
        return [];
      }
    }

    function saveWishlist(list) {
      localStorage.setItem(storageKey, JSON.stringify(list));
    }

    function updateButtonState() {
      var list = getWishlist();
      var isActive = list.indexOf(productId) !== -1;
      btn.classList.toggle('active', isActive);
      var label = btn.querySelector('span');
      if (label) label.textContent = isActive ? 'Added to wishlist' : 'Add to wishlist';
    }

    updateButtonState();

    btn.addEventListener('click', function () {
      var list = getWishlist();
      var index = list.indexOf(productId);
      if (index === -1) {
        list.push(productId);
      } else {
        list.splice(index, 1);
      }
      saveWishlist(list);
      updateButtonState();
    });
  }

  function initStickyAddToCart(root) {
    var bar = root.querySelector('[data-pi-sticky-bar]');
    var form = root.querySelector('#zb-pi-form');
    var stickyAddBtn = root.querySelector('[data-pi-sticky-add]');
    if (!bar) return;

    function toggleBar() {
      var rect = root.getBoundingClientRect();
      var barHeight = bar.offsetHeight || 70;
      var shouldShow = rect.top < -200 && rect.bottom > barHeight + 40;
      bar.classList.toggle('is-visible', shouldShow);
    }

    window.addEventListener('scroll', toggleBar, { passive: true });
    toggleBar();

    if (stickyAddBtn && form) {
      stickyAddBtn.addEventListener('click', function () {
        var submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.click();
      });
    }
  }

  function initShare(root) {
    var btn = root.querySelector('[data-share-button]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-url');
      var title = btn.getAttribute('data-title');

      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          var label = btn.textContent;
          btn.textContent = 'Link copied!';
          setTimeout(function () {
            btn.textContent = label;
          }, 2000);
        });
      }
    });
  }

  function initGiftCardToggle(root) {
    var checkbox = root.querySelector('[data-gift-card-toggle]');
    var fields = root.querySelector('[data-gift-card-fields]');
    if (!checkbox || !fields) return;

    checkbox.addEventListener('change', function () {
      fields.toggleAttribute('hidden', !checkbox.checked);
    });
  }

  function initReadMore(root) {
    var wraps = root.querySelectorAll('[data-pi-readmore-wrap]');
    wraps.forEach(function (wrap) {
      var btn = wrap.querySelector('[data-pi-readmore-toggle]');
      var textEl = wrap.querySelector('.zb-pi__seo-text');
      if (!btn || !textEl) return;

      if (textEl.scrollHeight <= textEl.clientHeight + 4) {
        btn.style.display = 'none';
        return;
      }

      btn.addEventListener('click', function () {
        var expanded = wrap.classList.toggle('expanded');
        btn.textContent = expanded ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
      });
    });
  }

  function initShippingEstimator(root) {
    var box = root.querySelector('[data-shipping-estimator]');
    if (!box) return;

    var btn = box.querySelector('[data-ship-estimate-btn]');
    var resultsEl = box.querySelector('[data-shipping-results]');
    var countrySelect = box.querySelector('[data-ship-country]');
    var provinceInput = box.querySelector('[data-ship-province]');
    var zipInput = box.querySelector('[data-ship-zip]');

    btn.addEventListener('click', function () {
      resultsEl.textContent = 'Calculating...';

      var params = new URLSearchParams({
        'shipping_address[zip]': zipInput.value,
        'shipping_address[country]': countrySelect.value,
        'shipping_address[province]': provinceInput.value
      });

      fetch('/cart/shipping_rates.json?' + params.toString())
        .then(function (res) {
          if (!res.ok) throw new Error('Failed to fetch rates');
          return res.json();
        })
        .then(function (data) {
          var rates = data.shipping_rates || [];
          if (!rates.length) {
            resultsEl.textContent = 'No shipping rates available for this destination.';
            return;
          }
          resultsEl.innerHTML = rates
            .map(function (rate) {
              return '<div>' + rate.name + ': ' + (rate.price / 100).toFixed(2) + '</div>';
            })
            .join('');
        })
        .catch(function () {
          resultsEl.textContent = 'Could not estimate shipping. Add an item to your cart first, then try again.';
        });
    });
  }

  function initComplementary(root) {
    var box = root.querySelector('[data-complementary-block]');
    if (!box) return;

    var productId = box.getAttribute('data-product-id');
    var limit = box.getAttribute('data-limit') || 4;
    var heading = box.getAttribute('data-heading') || 'Pairs well with';

    var url = '/recommendations/products.json?product_id=' + productId + '&limit=' + limit;

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to fetch recommendations');
        return res.json();
      })
      .then(function (data) {
        var products = data.products || [];
        if (!products.length) return;

        var itemsHtml = products
          .map(function (p, i) {
            var image = p.featured_image || (p.images && p.images[0]) || '';
            return (
              '<li class="zb-pi__comp-item-wrap">' +
              '<div class="zb-pi__complementary-item">' +
              '<a href="' + p.url + '" class="zb-pi__comp-link">' +
              '<img src="' + image + '&width=120" alt="" loading="lazy" width="60" height="60">' +
              '<span><span class="zb-pi__complementary-title">' + p.title + '</span>' +
              '<span class="zb-pi__complementary-price">' + p.price + '</span></span>' +
              '</a>' +
              '<button type="button" class="zb-pi__comp-toggle" data-comp-toggle data-handle="' + p.handle + '" aria-label="Quick add">+</button>' +
              '</div>' +
              '<div class="zb-pi__comp-expand" data-comp-expand hidden></div>' +
              '</li>'
            );
          })
          .join('');

        box.innerHTML =
          '<p class="zb-pi__complementary-heading">' + heading + '</p>' +
          '<ul class="zb-pi__complementary-list">' + itemsHtml + '</ul>';

        initQuickAddToggles(box);
      })
      .catch(function () {});
  }

  function initQuickAddToggles(box) {
    box.querySelectorAll('[data-comp-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.zb-pi__comp-item-wrap');
        var expand = wrap.querySelector('[data-comp-expand]');
        var isOpen = !expand.hasAttribute('hidden');

        if (isOpen) {
          expand.setAttribute('hidden', '');
          expand.innerHTML = '';
          btn.textContent = '+';
          return;
        }

        btn.textContent = '\u2212';
        expand.removeAttribute('hidden');
        expand.innerHTML = '<div class="zb-pi__comp-loading">Loading...</div>';

        fetch('/products/' + btn.getAttribute('data-handle') + '.js')
          .then(function (res) {
            if (!res.ok) throw new Error('Failed to load product');
            return res.json();
          })
          .then(function (product) {
            renderQuickAdd(expand, product);
          })
          .catch(function () {
            expand.innerHTML = '<div class="zb-pi__comp-loading">Could not load product.</div>';
          });
      });
    });
  }

  function renderQuickAdd(expand, product) {
    // Placeholder for quick add functionality
  }

  function initSection(root) {
    initMediaGallery(root);
    initQuantity(root);
    initVariantPicker(root);
    initSizingGuide(root);
    initSidePanels(root);
    initCollapsibleRows(root);
    initWishlist(root);
    initStickyAddToCart(root);
    initShare(root);
    initGiftCardToggle(root);
    initReadMore(root);
    initShippingEstimator(root);
    initComplementary(root);
  }

  function removeNativeStickyBar() {
    document.querySelectorAll('product-add-to-cart-sticky').forEach(function (el) {
      el.remove();
    });
  }

  function initAll() {
    console.log('🚀 Initializing ZB Product Information v5');
    document.querySelectorAll('.zb-pi').forEach(initSection);
    removeNativeStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  var nativeStickyObserver = new MutationObserver(function () {
    removeNativeStickyBar();
  });
  nativeStickyObserver.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.zb-pi');
    if (root) {
      initSection(root);
    }
  });
})();